import LocationForm from '../../../../LocationEditForm/Location';

export default LocationForm;
